export const exportHeaders = {
    numeroSolicitacao: "Número Solicitação",
    nomeUnidadeGerencia: "Unidade/Gerência",
    tituloFormulario: "Modelo do Formulário",
    tipoAssociacao: "Tipo de Associação",
    nomeProcesso: "Nome do Processo",
    dataEnvioResposta: "Data do Envio da Resposta do Formulário",
};

/**
 * Retorna o conjunto de todos os headers presentes no array de objetos
 */
export function getAllHeaders(exportData) {
    const headersSet = new Set();
    exportData.forEach(rowObj => {
        Object.keys(rowObj).forEach(k => {
            if (k && k !== 'key') headersSet.add(exportHeaders[k] || k);
        });
    });
    return Array.from(headersSet);
}

/**
 * Formata as linhas para garantir todas as colunas e ordenação correta
 */
export function getExportRows(exportData, headers) {
    return exportData.map(rowObj => headers.map(h => rowObj[h] ?? ""));
}

/**
 * Aplica estilos profissionais no header e zebra no corpo
 */
export function styleWorksheet(worksheet, headers) {
    // Header: fonte Calibri, negrito, branca, fundo azul #2b97be
    worksheet.getRow(1).height = 50; // <-- aumenta a altura do header

    for (let i = 1; i <= headers.length; i++) {
        const cell = worksheet.getRow(1).getCell(i);
        cell.font = { name: "Calibri", bold: true, size: 13, color: { argb: "FFFFFFFF" } }; // branco
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF2B97BE" } // azul #2b97be
        };
        cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };

        // Aplica borda em volta de cada célula do header
        cell.border = {
            top: { style: "thin", color: { argb: "FFAAAAAA" } },
            left: { style: "thin", color: { argb: "FFAAAAAA" } },
            bottom: { style: "thin", color: { argb: "FFAAAAAA" } },
            right: { style: "thin", color: { argb: "FFAAAAAA" } }
        };
    }

    // Corpo: Calibri normal, zebra, borda fina
    worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return; // já estilizado acima

        for (let i = 1; i <= headers.length; i++) {
            const cell = row.getCell(i);

            // Zebra (linhas pares)
            if (rowNumber % 2 === 0) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFF6F7F9" },
                };
            }

            // Borda fina
            cell.border = {
                top: { style: "thin", color: { argb: "FFAAAAAA" } },
                left: { style: "thin", color: { argb: "FFAAAAAA" } },
                bottom: { style: "thin", color: { argb: "FFAAAAAA" } },
                right: { style: "thin", color: { argb: "FFAAAAAA" } }
            };

            // Fonte Calibri
            cell.font = { name: "Calibri", size: 12 };
            cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        }
    });

    // Ajuste de largura das colunas
    const FILTER_EXTRA = 10;
    for (let i = 1; i <= headers.length; i++) {
        const col = worksheet.getColumn(i);
        let maxLen = col.header ? col.header.length : 10;
        col.eachCell({ includeEmpty: true }, (cell) => {
            const value = cell.value ? cell.value.toString() : "";
            if (value.length > maxLen) maxLen = value.length;
        });
        col.width = Math.max(Math.min(maxLen + FILTER_EXTRA, 60), 14);
    }

    // Filtro nos headers apenas até headers.length
    worksheet.autoFilter = {
        from: { row: 1, column: 1 },
        to: { row: 1, column: headers.length }
    };
}

/**
 * Monta os dados exportáveis já formatados (labels)
 */
export function buildExportData(data) {
    return data.map(obj => {
        const newRow = {};
        Object.entries(obj).forEach(([k, v]) => {
            if (k !== "key" && k !== "" && k !== undefined && k !== null) {
                newRow[exportHeaders[k] || k] = v;
            }
        });
        return newRow;
    });
}

